import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadFlstmListStatus: 'idle',
    loadFlstmListError: undefined as any,
    loadFlstmListLastArgs: undefined as any,
    loadFlstmStatus: 'idle',
    loadFlstmError: undefined as any,
    saveFlstmStatus: 'idle',
    saveFlstmError: undefined as any,
    deleteFlstmStatus: 'idle',
    deleteFlstmError: undefined as any,
    loadGebaeudeRelStatus: 'idle',
    loadGebaeudeRelError: undefined as any,
    saveGebaeudeRelStatus: 'idle',
    saveGebaeudeRelError: undefined as any,
    deleteGebaeudeRelStatus: 'idle',
    deleteGebaeudeRelError: undefined as any,
    loadGebaeudeTeilRelStatus: 'idle',
    loadGebaeudeTeilRelError: undefined as any,
    saveGebaeudeTeilRelStatus: 'idle',
    saveGebaeudeTeilRelError: undefined as any,
    deleteGebaeudeTeilRelStatus: 'idle',
    deleteGebaeudeTeilRelError: undefined as any,
    loadGeschossRelStatus: 'idle',
    loadGeschossRelError: undefined as any,
    saveGeschossRelStatus: 'idle',
    saveGeschossRelError: undefined as any,
    deleteGeschossRelStatus: 'idle',
    deleteGeschossRelError: undefined as any,
    loadHauptflaecheStatus: 'idle',
    loadHauptflaecheError: undefined as any,
    loadUnterflaecheStatus: 'idle',
    loadUnterflaecheError: undefined as any,
    addHauptflaecheStatus: 'idle',
    addHauptflaecheError: undefined as any,
    updateHauptflaecheStatus: 'idle',
    updateHauptflaecheError: undefined as any,
    deleteHauptflaecheStatus: 'idle',
    deleteHauptflaecheError: undefined as any,

    flstmList: [] as any[],
    btKreisRelGebaeude: undefined as any,
    btKreisRelGebaeudeTeil: undefined as any,
    btKreisRelGeschoss: undefined as any,
    formItem: undefined as any,
    hauptflaecheSevLink: undefined as any,
    unterflaecheSevLink: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadFlstmList = createAsyncThunk('flstmSlice/loadFlstmList', async ({ globalFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().flstmSlice.loadFlstmListLastArgs
    if (_.isEqual(lastArgs, { globalFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/flstm/`, globalFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { globalFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadFlstmListStatus } = getState().flstmSlice
        return loadFlstmListStatus !== 'pending'
    }
})

export const loadFlstm = createAsyncThunk('flstmSlice/loadFlstm', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/flstm/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadFlstmStatus } = getState().flstmSlice
        return loadFlstmStatus !== 'pending'
    }
})

export const saveFlstm = createAsyncThunk('flstmSlice/saveFlstm', async ({ flstm }: any, { rejectWithValue }: any) => {
    let promises = []
    if (flstm?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/flstm/${ flstm?.HDR_ID }/`,
            prepareData(flstm),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/flstm/`,
            prepareData(flstm),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveFlstmStatus } = getState().flstmSlice
        return saveFlstmStatus !== 'pending'
    }
})

export const deleteFlstm = createAsyncThunk('flstmSlice/deleteFlstm', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/flstm/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteFlstmStatus } = getState().flstmSlice
        return deleteFlstmStatus !== 'pending'
    }
})

export const loadGebaeudeRel = createAsyncThunk('flstmSlice/loadGebaeudeRel', async ({ flstm, btKreisTypGebaeude }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkreisflstmrel/?action=eql&FLSTMID=${flstm.HDR_ID}&BTKREISTYPID=${btKreisTypGebaeude.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGebaeudeRelStatus } = getState().flstmSlice
        return loadGebaeudeRelStatus !== 'pending'
    }
})

export const saveGebaeudeRel = createAsyncThunk('flstmSlice/saveGebaeudeRel', async ({ flstm, btKreisRelGebaeude }: any, { rejectWithValue }: any) => {
    let promises = []
    if (btKreisRelGebaeude?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/btkreisflstmrel/${ btKreisRelGebaeude?.HDR_ID }/`,
            prepareData({ FLSTMID: flstm.HDR_ID, FLSTATIC: 1, ...btKreisRelGebaeude, BTKREISID: flstm.btKreisRelGebaeude }),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/btkreisflstmrel/`,
            prepareData({ FLSTMID: flstm.HDR_ID, FLSTATIC: 1, ...btKreisRelGebaeude, BTKREISID: flstm.btKreisRelGebaeude }),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveGebaeudeRelStatus } = getState().flstmSlice
        return saveGebaeudeRelStatus !== 'pending'
    }
})

export const deleteGebaeudeRel = createAsyncThunk('flstmSlice/deleteGebaeudeRel', async ({ btKreisRelGebaeude }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/btkreisflstmrel/${btKreisRelGebaeude.HDR_ID}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteGebaeudeRelStatus } = getState().flstmSlice
        return deleteGebaeudeRelStatus !== 'pending'
    }
})

export const loadGebaeudeTeilRel = createAsyncThunk('flstmSlice/loadGebaeudeTeilRel', async ({ flstm, btKreisTypGebaeudeTeil }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkreisflstmrel/?action=eql&FLSTMID=${flstm.HDR_ID}&BTKREISTYPID=${btKreisTypGebaeudeTeil.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGebaeudeTeilRelStatus } = getState().flstmSlice
        return loadGebaeudeTeilRelStatus !== 'pending'
    }
})

export const saveGebaeudeTeilRel = createAsyncThunk('flstmSlice/saveGebaeudeTeilRel', async ({ flstm, btKreisRelGebaeudeTeil }: any, { rejectWithValue }: any) => {
    let promises = []
    if (btKreisRelGebaeudeTeil?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/btkreisflstmrel/${ btKreisRelGebaeudeTeil?.HDR_ID }/`,
            prepareData({ FLSTMID: flstm.HDR_ID, FLSTATIC: 1, ...btKreisRelGebaeudeTeil, BTKREISID: flstm.btKreisRelGebaeudeTeil }),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/btkreisflstmrel/`,
            prepareData({ FLSTMID: flstm.HDR_ID, FLSTATIC: 1, ...btKreisRelGebaeudeTeil, BTKREISID: flstm.btKreisRelGebaeudeTeil }),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveGebaeudeTeilRelStatus } = getState().flstmSlice
        return saveGebaeudeTeilRelStatus !== 'pending'
    }
})

export const deleteGebaeudeTeilRel = createAsyncThunk('flstmSlice/deleteGebaeudeTeilRel', async ({ btKreisRelGebaeudeTeil }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/btkreisflstmrel/${btKreisRelGebaeudeTeil.HDR_ID}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteGebaeudeTeilRelStatus } = getState().flstmSlice
        return deleteGebaeudeTeilRelStatus !== 'pending'
    }
})

export const loadGeschossRel = createAsyncThunk('flstmSlice/loadGeschossRel', async ({ flstm, btKreisTypGeschoss }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkreisflstmrel/?action=eql&FLSTMID=${flstm.HDR_ID}&BTKREISTYPID=${btKreisTypGeschoss.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGeschossRelStatus } = getState().flstmSlice
        return loadGeschossRelStatus !== 'pending'
    }
})

export const saveGeschossRel = createAsyncThunk('flstmSlice/saveGeschossRel', async ({ flstm, btKreisRelGeschoss }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/btkreisflstmrel/`,
        prepareData({ FLSTMID: flstm.HDR_ID, FLSTATIC: 1,  ...btKreisRelGeschoss, BTKREISID: flstm.btKreisRelGeschoss }),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveGeschossRelStatus } = getState().flstmSlice
        return saveGeschossRelStatus !== 'pending'
    }
})

export const deleteGeschossRel = createAsyncThunk('flstmSlice/deleteGeschossRel', async ({ btKreisRelGeschoss }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/btkreisflstmrel/${btKreisRelGeschoss.HDR_ID}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteGeschossRelStatus } = getState().flstmSlice
        return deleteGeschossRelStatus !== 'pending'
    }
})

export const loadHauptflaeche = createAsyncThunk('flstmSlice/loadHauptflaeche', async ({ flstm }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/sevlk/?SUBAREAID=${flstm.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadHauptflaecheStatus } = getState().flstmSlice
        return loadHauptflaecheStatus !== 'pending'
    }
})

export const loadUnterflaeche = createAsyncThunk('flstmSlice/loadUnterflaeche', async ({ flstm }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/sevlk/?MAINAREAID=${flstm.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUnterflaecheStatus } = getState().flstmSlice
        return loadUnterflaecheStatus !== 'pending'
    }
})

export const addHauptflaeche = createAsyncThunk('flstmSlice/addHauptflaeche', async ({ flstm, hauptflaecheSevLink }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/sevlk/`,
        prepareData(hauptflaecheSevLink),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { addHauptflaecheStatus } = getState().flstmSlice
        return addHauptflaecheStatus !== 'pending'
    }
})

export const updateHauptflaeche = createAsyncThunk('flstmSlice/updateHauptflaeche', async ({ flstm, hauptflaecheSevLink }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.put(
        `/api/ixweb/sevln/${hauptflaecheSevLink.HDR_ID}/`,
        prepareData(hauptflaecheSevLink),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { updateHauptflaecheStatus } = getState().flstmSlice
        return updateHauptflaecheStatus !== 'pending'
    }
})

export const deleteHauptflaeche = createAsyncThunk('flstmSlice/deleteHauptflaeche', async ({ flstm, hauptflaecheSevLink }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/sevln/${hauptflaecheSevLink.HDR_ID}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteHauptflaecheStatus } = getState().flstmSlice
        return deleteHauptflaecheStatus !== 'pending'
    }
})

const FlstmSlice = createSlice({
    name: 'flstmSlice',
    initialState,
    reducers: {
        resetloadFlstmListError: (state) => {
            state.loadFlstmListError = undefined
        },
        resetloadFlstm: (state) => {
            state.formItem = undefined
            state.loadFlstmError = undefined
        },
        resetloadFlstmError: (state) => {
            state.loadFlstmError = undefined
        },
        resetsaveFlstm: (state) => {
            state.formItem = undefined
            state.saveFlstmError = undefined
        },
        resetsaveFlstmError: (state) => {
            state.saveFlstmError = undefined
        },
        resetdeleteFlstmError: (state) => {
            state.deleteFlstmError = undefined
        },
        resetloadGebaeudeRel: (state) => {
            state.btKreisRelGebaeude = undefined
            state.loadGebaeudeRelError = undefined
        },
        resetloadGebaeudeRelError: (state) => {
            state.loadGebaeudeRelError = undefined
        },
        resetsaveGebaeudeRel: (state) => {
            state.btKreisRelGebaeude = undefined
            state.saveGebaeudeRelError = undefined
        },
        resetsaveGebaeudeRelError: (state) => {
            state.saveGebaeudeRelError = undefined
        },
        resetdeleteGebaeudeRelError: (state) => {
            state.deleteGebaeudeRelError = undefined
        },
        resetloadGebaeudeTeilRel: (state) => {
            state.btKreisRelGebaeudeTeil = undefined
            state.loadGebaeudeTeilRelError = undefined
        },
        resetloadGebaeudeTeilRelError: (state) => {
            state.loadGebaeudeTeilRelError = undefined
        },
        resetsaveGebaeudeTeilRel: (state) => {
            state.btKreisRelGebaeudeTeil = undefined
            state.saveGebaeudeTeilRelError = undefined
        },
        resetsaveGebaeudeTeilRelError: (state) => {
            state.saveGebaeudeTeilRelError = undefined
        },
        resetdeleteGebaeudeTeilRelError: (state) => {
            state.deleteGebaeudeTeilRelError = undefined
        },
        resetloadGeschossRel: (state) => {
            state.btKreisRelGeschoss = undefined
            state.loadGeschossRelError = undefined
        },
        resetloadGeschossRelError: (state) => {
            state.loadGeschossRelError = undefined
        },
        resetsaveGeschossRel: (state) => {
            state.btKreisRelGeschoss = undefined
            state.saveGeschossRelError = undefined
        },
        resetsaveGeschossRelError: (state) => {
            state.saveGeschossRelError = undefined
        },
        resetdeleteGeschossRelError: (state) => {
            state.deleteGeschossRelError = undefined
        },
        resetloadHauptflaeche: (state) => {
            state.hauptflaecheSevLink = undefined
            state.loadHauptflaecheError = undefined
        },
        resetloadHauptflaecheError: (state) => {
            state.loadHauptflaecheError = undefined
        },
        resetloadUnterflaeche: (state) => {
            state.unterflaecheSevLink = undefined
            state.loadUnterflaecheError = undefined
        },
        resetloadUnterflaecheError: (state) => {
            state.loadUnterflaecheError = undefined
        },
        resetaddHauptflaeche: (state) => {
            state.hauptflaecheSevLink = undefined
            state.addHauptflaecheError = undefined
        },
        resetaddHauptflaecheError: (state) => {
            state.addHauptflaecheError = undefined
        },
        resetupdateHauptflaeche: (state) => {
            state.hauptflaecheSevLink = undefined
            state.updateHauptflaecheError = undefined
        },
        resetupdateHauptflaecheError: (state) => {
            state.updateHauptflaecheError = undefined
        },
        resetdeleteHauptflaecheError: (state) => {
            state.deleteHauptflaecheError = undefined
        },
        removeFromFlstmListById: (state, action) => {
            state.flstmList = state.flstmList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFlstmListByIds: (state, action) => {
            state.flstmList = state.flstmList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flstmList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadFlstmListStatus = 'preloaded'
            state.loadFlstmListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.flstmList = []
            state.loadFlstmListStatus = 'idle'
            state.loadFlstmListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadFlstmList.pending, (state) => {
            state.loadFlstmListStatus = 'pending'
            state.loadFlstmListError = undefined
        })
        builder.addCase(loadFlstmList.fulfilled, (state, action) => {
            state.loadFlstmListStatus = 'idle'

            if (!action.payload) { return }

            state.loadFlstmListLastArgs = action.payload.args

            {
                state.flstmList = action.payload.data

            }
        })
        builder.addCase(loadFlstmList.rejected, (state, action) => {
            state.loadFlstmListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadFlstmListError = action.error.message
            } else {
                state.loadFlstmListError = action.payload
            }
        })

        builder.addCase(loadFlstm.pending, (state) => {
            state.loadFlstmStatus = 'pending'
            state.loadFlstmError = undefined
        })
        builder.addCase(loadFlstm.fulfilled, (state, action) => {
            state.loadFlstmStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flstmList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flstmList.push(newItem) }
                else { state.flstmList[i] = { ...state.flstmList[i], ...newItem } }
            }
        })
        builder.addCase(loadFlstm.rejected, (state, action) => {
            state.loadFlstmStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadFlstmError = action.error.message
            } else {
                state.loadFlstmError = action.payload
            }
        })

        builder.addCase(saveFlstm.pending, (state) => {
            state.saveFlstmStatus = 'pending'
            state.saveFlstmError = undefined
        })
        builder.addCase(saveFlstm.fulfilled, (state, action) => {
            state.saveFlstmStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flstmList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flstmList.push(newItem) }
                else { state.flstmList[i] = { ...state.flstmList[i], ...newItem } }
            }
        })
        builder.addCase(saveFlstm.rejected, (state, action) => {
            state.saveFlstmStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveFlstmError = action.error.message
            } else {
                state.saveFlstmError = action.payload
            }
        })

        builder.addCase(deleteFlstm.pending, (state) => {
            state.deleteFlstmStatus = 'pending'
            state.deleteFlstmError = undefined
        })
        builder.addCase(deleteFlstm.fulfilled, (state, action) => {
            state.deleteFlstmStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.flstmList = state.flstmList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.flstmList = state.flstmList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteFlstm.rejected, (state, action) => {
            state.deleteFlstmStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteFlstmError = action.error.message
            } else {
                state.deleteFlstmError = action.payload
            }
        })

        builder.addCase(loadGebaeudeRel.pending, (state) => {
            state.loadGebaeudeRelStatus = 'pending'
            state.loadGebaeudeRelError = undefined
        })
        builder.addCase(loadGebaeudeRel.fulfilled, (state, action) => {
            state.loadGebaeudeRelStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisRelGebaeude = newItem
            }
        })
        builder.addCase(loadGebaeudeRel.rejected, (state, action) => {
            state.loadGebaeudeRelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGebaeudeRelError = action.error.message
            } else {
                state.loadGebaeudeRelError = action.payload
            }
        })

        builder.addCase(saveGebaeudeRel.pending, (state) => {
            state.saveGebaeudeRelStatus = 'pending'
            state.saveGebaeudeRelError = undefined
        })
        builder.addCase(saveGebaeudeRel.fulfilled, (state, action) => {
            state.saveGebaeudeRelStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisRelGebaeude = newItem
            }
        })
        builder.addCase(saveGebaeudeRel.rejected, (state, action) => {
            state.saveGebaeudeRelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveGebaeudeRelError = action.error.message
            } else {
                state.saveGebaeudeRelError = action.payload
            }
        })

        builder.addCase(deleteGebaeudeRel.pending, (state) => {
            state.deleteGebaeudeRelStatus = 'pending'
            state.deleteGebaeudeRelError = undefined
        })
        builder.addCase(deleteGebaeudeRel.fulfilled, (state, action) => {
            state.deleteGebaeudeRelStatus = 'idle'

            {
                if (state.btKreisRelGebaeude && action.payload === state.btKreisRelGebaeude.HDR_ID) {
                    state.btKreisRelGebaeude = undefined
                }
            }
        })
        builder.addCase(deleteGebaeudeRel.rejected, (state, action) => {
            state.deleteGebaeudeRelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteGebaeudeRelError = action.error.message
            } else {
                state.deleteGebaeudeRelError = action.payload
            }
        })

        builder.addCase(loadGebaeudeTeilRel.pending, (state) => {
            state.loadGebaeudeTeilRelStatus = 'pending'
            state.loadGebaeudeTeilRelError = undefined
        })
        builder.addCase(loadGebaeudeTeilRel.fulfilled, (state, action) => {
            state.loadGebaeudeTeilRelStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisRelGebaeudeTeil = newItem
            }
        })
        builder.addCase(loadGebaeudeTeilRel.rejected, (state, action) => {
            state.loadGebaeudeTeilRelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGebaeudeTeilRelError = action.error.message
            } else {
                state.loadGebaeudeTeilRelError = action.payload
            }
        })

        builder.addCase(saveGebaeudeTeilRel.pending, (state) => {
            state.saveGebaeudeTeilRelStatus = 'pending'
            state.saveGebaeudeTeilRelError = undefined
        })
        builder.addCase(saveGebaeudeTeilRel.fulfilled, (state, action) => {
            state.saveGebaeudeTeilRelStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisRelGebaeudeTeil = newItem
            }
        })
        builder.addCase(saveGebaeudeTeilRel.rejected, (state, action) => {
            state.saveGebaeudeTeilRelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveGebaeudeTeilRelError = action.error.message
            } else {
                state.saveGebaeudeTeilRelError = action.payload
            }
        })

        builder.addCase(deleteGebaeudeTeilRel.pending, (state) => {
            state.deleteGebaeudeTeilRelStatus = 'pending'
            state.deleteGebaeudeTeilRelError = undefined
        })
        builder.addCase(deleteGebaeudeTeilRel.fulfilled, (state, action) => {
            state.deleteGebaeudeTeilRelStatus = 'idle'

            {
                if (state.btKreisRelGebaeudeTeil && action.payload === state.btKreisRelGebaeudeTeil.HDR_ID) {
                    state.btKreisRelGebaeudeTeil = undefined
                }
            }
        })
        builder.addCase(deleteGebaeudeTeilRel.rejected, (state, action) => {
            state.deleteGebaeudeTeilRelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteGebaeudeTeilRelError = action.error.message
            } else {
                state.deleteGebaeudeTeilRelError = action.payload
            }
        })

        builder.addCase(loadGeschossRel.pending, (state) => {
            state.loadGeschossRelStatus = 'pending'
            state.loadGeschossRelError = undefined
        })
        builder.addCase(loadGeschossRel.fulfilled, (state, action) => {
            state.loadGeschossRelStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisRelGeschoss = newItem
            }
        })
        builder.addCase(loadGeschossRel.rejected, (state, action) => {
            state.loadGeschossRelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGeschossRelError = action.error.message
            } else {
                state.loadGeschossRelError = action.payload
            }
        })

        builder.addCase(saveGeschossRel.pending, (state) => {
            state.saveGeschossRelStatus = 'pending'
            state.saveGeschossRelError = undefined
        })
        builder.addCase(saveGeschossRel.fulfilled, (state, action) => {
            state.saveGeschossRelStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btKreisRelGeschoss = newItem
            }
        })
        builder.addCase(saveGeschossRel.rejected, (state, action) => {
            state.saveGeschossRelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveGeschossRelError = action.error.message
            } else {
                state.saveGeschossRelError = action.payload
            }
        })

        builder.addCase(deleteGeschossRel.pending, (state) => {
            state.deleteGeschossRelStatus = 'pending'
            state.deleteGeschossRelError = undefined
        })
        builder.addCase(deleteGeschossRel.fulfilled, (state, action) => {
            state.deleteGeschossRelStatus = 'idle'

            {
                if (state.btKreisRelGeschoss && action.payload === state.btKreisRelGeschoss.HDR_ID) {
                    state.btKreisRelGeschoss = undefined
                }
            }
        })
        builder.addCase(deleteGeschossRel.rejected, (state, action) => {
            state.deleteGeschossRelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteGeschossRelError = action.error.message
            } else {
                state.deleteGeschossRelError = action.payload
            }
        })

        builder.addCase(loadHauptflaeche.pending, (state) => {
            state.loadHauptflaecheStatus = 'pending'
            state.loadHauptflaecheError = undefined
        })
        builder.addCase(loadHauptflaeche.fulfilled, (state, action) => {
            state.loadHauptflaecheStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.hauptflaecheSevLink = newItem
            }
        })
        builder.addCase(loadHauptflaeche.rejected, (state, action) => {
            state.loadHauptflaecheStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadHauptflaecheError = action.error.message
            } else {
                state.loadHauptflaecheError = action.payload
            }
        })

        builder.addCase(loadUnterflaeche.pending, (state) => {
            state.loadUnterflaecheStatus = 'pending'
            state.loadUnterflaecheError = undefined
        })
        builder.addCase(loadUnterflaeche.fulfilled, (state, action) => {
            state.loadUnterflaecheStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.unterflaecheSevLink = newItem
            }
        })
        builder.addCase(loadUnterflaeche.rejected, (state, action) => {
            state.loadUnterflaecheStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUnterflaecheError = action.error.message
            } else {
                state.loadUnterflaecheError = action.payload
            }
        })

        builder.addCase(addHauptflaeche.pending, (state) => {
            state.addHauptflaecheStatus = 'pending'
            state.addHauptflaecheError = undefined
        })
        builder.addCase(addHauptflaeche.fulfilled, (state, action) => {
            state.addHauptflaecheStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.hauptflaecheSevLink = newItem
            }
        })
        builder.addCase(addHauptflaeche.rejected, (state, action) => {
            state.addHauptflaecheStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.addHauptflaecheError = action.error.message
            } else {
                state.addHauptflaecheError = action.payload
            }
        })

        builder.addCase(updateHauptflaeche.pending, (state) => {
            state.updateHauptflaecheStatus = 'pending'
            state.updateHauptflaecheError = undefined
        })
        builder.addCase(updateHauptflaeche.fulfilled, (state, action) => {
            state.updateHauptflaecheStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.hauptflaecheSevLink = newItem
            }
        })
        builder.addCase(updateHauptflaeche.rejected, (state, action) => {
            state.updateHauptflaecheStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.updateHauptflaecheError = action.error.message
            } else {
                state.updateHauptflaecheError = action.payload
            }
        })

        builder.addCase(deleteHauptflaeche.pending, (state) => {
            state.deleteHauptflaecheStatus = 'pending'
            state.deleteHauptflaecheError = undefined
        })
        builder.addCase(deleteHauptflaeche.fulfilled, (state, action) => {
            state.deleteHauptflaecheStatus = 'idle'

            {
                if (state.hauptflaecheSevLink && action.payload === state.hauptflaecheSevLink.HDR_ID) {
                    state.hauptflaecheSevLink = undefined
                }
            }
        })
        builder.addCase(deleteHauptflaeche.rejected, (state, action) => {
            state.deleteHauptflaecheStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteHauptflaecheError = action.error.message
            } else {
                state.deleteHauptflaecheError = action.payload
            }
        })

    }
})

export const {
    resetloadFlstmListError,
    resetloadFlstm,
    resetloadFlstmError,
    resetsaveFlstm,
    resetsaveFlstmError,
    resetdeleteFlstmError,
    resetloadGebaeudeRel,
    resetloadGebaeudeRelError,
    resetsaveGebaeudeRel,
    resetsaveGebaeudeRelError,
    resetdeleteGebaeudeRelError,
    resetloadGebaeudeTeilRel,
    resetloadGebaeudeTeilRelError,
    resetsaveGebaeudeTeilRel,
    resetsaveGebaeudeTeilRelError,
    resetdeleteGebaeudeTeilRelError,
    resetloadGeschossRel,
    resetloadGeschossRelError,
    resetsaveGeschossRel,
    resetsaveGeschossRelError,
    resetdeleteGeschossRelError,
    resetloadHauptflaeche,
    resetloadHauptflaecheError,
    resetloadUnterflaeche,
    resetloadUnterflaecheError,
    resetaddHauptflaeche,
    resetaddHauptflaecheError,
    resetupdateHauptflaeche,
    resetupdateHauptflaecheError,
    resetdeleteHauptflaecheError,
    removeFromFlstmListById,
    removeFromFlstmListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlstmSlice.actions
export default FlstmSlice.reducer
